import { useArchiveAppRewardConfig } from '@hooks/mutations/registry/onboarding/useArchiveAppRewardConfig';
import { AppRewardConfiguration } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Configuration/AppReward';
import { ChoiceDialogProps } from '../../components/ChoiceDialog';
import { useParties } from '../../contexts/PartiesContext';
import TemplateContract from '../../utils/TemplateContract';
import { UpdateWeightDialog } from '../registry/onboarding/UpdateWeightDialog';

export const useCreateAppRewardActions = (
  onClose: () => void,
  row?: TemplateContract<AppRewardConfiguration>,
) => {
  const actions: ChoiceDialogProps['actions'] = [];
  const archive = useArchiveAppRewardConfig();
  const { party } = useParties();
  if (!row) {
    return actions;
  }
  const onArchive = async (r: TemplateContract<AppRewardConfiguration>) => {
    await archive({ cid: r.contractId, argument: {} });
    onClose();
  };
  const isOperator = party === row.payload.operator;
  if (isOperator) {
    actions.push({
      name: 'Modify Configuration',
      form: <UpdateWeightDialog disableDialog open onClose={onClose} row={row} />,
    });
    actions.push({
      name: 'Archive',
      color: 'error',
      action: async () => {
        await onArchive(row);
      },
    });
  }
  return actions;
};
